import React, { useEffect, useState } from 'react';
const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [{
    image: 'https://cdn.magicpatterns.com/uploads/9bRLzb2yD8yhvSM78PxnAX/8_X_10.jpg',
    alt: 'Ayevbosa and Abiodun elegant portrait'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/8ojujGKkWCeyn6idCj3qJh/background.png',
    alt: 'Ayevbosa and Abiodun together'
  }];
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  return <section id="home" className="relative h-screen flex items-center justify-center bg-sage bg-opacity-30 overflow-hidden" data-id="element-95">
      {/* Sliding background images */}
      {slides.map((slide, index) => <div key={index} className={`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`} style={{
      backgroundImage: `url(${slide.image})`
    }} data-id="element-96" />)}

      <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-black/60" data-id="element-97"></div>

      <div className="relative z-10 text-center px-4 max-w-3xl mx-auto fade-in" data-id="element-98">
        <p className="font-sans text-sm md:text-base uppercase tracking-widest mb-4 text-white" data-id="element-99">
          We're getting married
        </p>
        <h1 className="font-script text-6xl md:text-8xl mb-6 text-white leading-tight" data-id="element-100">
          Ayevbosa{' '}
          <span className="inline-block mx-2 text-emerald-light" data-id="element-101">&</span>{' '}
          Abiodun
        </h1>
        <div className="w-24 h-0.5 bg-emerald-light mx-auto my-8" data-id="element-102"></div>
        <p className="font-elegant text-xl md:text-2xl mb-6 text-white" data-id="element-103">
          February 14, 2026 • Ibadan, Oyo State
        </p>
        <a href="#rsvp" className="inline-block mt-6 px-8 py-3 bg-emerald text-white font-sans text-sm uppercase tracking-wider hover:bg-emerald-dark transition-all duration-300" data-id="element-104">
          RSVP
        </a>
      </div>

      {/* Slide indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-2 z-20" data-id="element-105">
        {slides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2 h-2 rounded-full transition-all duration-300 ${index === currentSlide ? 'bg-emerald-light w-8' : 'bg-white/50'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-106" />)}
      </div>
    </section>;
};
export default Hero;